/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService
 */

export const getDefaultSectionConfigsRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'getDefaultSectionConfigs',
  auth: 'app',
  fingerprint: 'Ak1sdGdNuRPVyhP8tuHcwsDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAdminBoardCardConfigRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'getAdminBoardCardConfig',
  auth: 'app',
  fingerprint: 'uSsGDg7wrc_VyhP8tuHcwsDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserBoardCardConfigRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'getUserBoardCardConfig',
  auth: 'app',
  fingerprint: 'uSsGDg7wrc_VyhP8tuHcwsDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createUserBoardCardConfigRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'createUserBoardCardConfig',
  auth: 'app',
  fingerprint: 'Ej0bU1R-vQ7VyhP8tuHcwsDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAdminBoardCardConfigRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'createAdminBoardCardConfig',
  auth: 'app',
  fingerprint: 'Ej0bU1R-vQ7VyhP8tuHcwsDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteUserBoardCardConfigsForUserRpc = {
  serviceName: 'com.hubspot.crm.pipeline.board.configuration.rpc.CrmPipelineBoardConfigurationService',
  rpcName: 'deleteUserBoardCardConfigsForUser',
  auth: 'app',
  fingerprint: 'uSsGDg7wrc92KmT5wCeUBcDaAtygrYx0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};